import React from 'react'
import PropTypes from 'prop-types'

const propTypes = {
  children: PropTypes.node,
}

const ArticleContainer = ({ children }) => {
  return <div className="lg:bg-gradient-r-sidebar relative">{children}</div>
}

ArticleContainer.propTypes = propTypes

export default ArticleContainer
